import { render, staticRenderFns } from "./EmailParentCarerDialog.vue?vue&type=template&id=6383c493&scoped=true&"
import script from "./EmailParentCarerDialog.vue?vue&type=script&lang=js&"
export * from "./EmailParentCarerDialog.vue?vue&type=script&lang=js&"
import style0 from "./EmailParentCarerDialog.vue?vue&type=style&index=0&id=6383c493&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6383c493",
  null
  
)

export default component.exports